import {
  startToolOperation,
  trackToolRejection,
  type ToolAnalyticsContext,
  type ToolErrorCode,
  type ToolOperation,
} from '@saas-pages/shared/public/runtime'
import type { ScanInputMethod } from '@/pages/qr-scanner/scannerModel'

function context(inputMethod: ScanInputMethod): ToolAnalyticsContext {
  return {
    app: 'qrka',
    domain: 'qrka.ru',
    route: '/skaner-qr-koda',
    utility: 'qr-scanner',
    processingMode: 'local',
    inputMethod,
  }
}

export function startScannerOperation(inputMethod: ScanInputMethod): ToolOperation {
  return startToolOperation(context(inputMethod))
}

export function trackScannerRejection(
  inputMethod: ScanInputMethod,
  errorCode: ToolErrorCode,
): void {
  trackToolRejection(context(inputMethod), errorCode)
}
